import * as Baseline from './Baseline'
import React, { useContext, useState } from 'react';

import { useAggregatedState } from '../../helpers';

export const PluginContext = React.createContext(null);

// wpApAdminSettings is a global variable defined in WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _wpApAdminSettings = {};
if (typeof variable !== 'wpApAdminSettings') {
	 _wpApAdminSettings = window['wpApAdminSettings'];
}

const { Provider } = PluginContext;
export const PluginProvider = ({ ...props }) => {

	 const [plugin, setPlugin] = useAggregatedState({
		  siteUid: _wpApAdminSettings ? _wpApAdminSettings.siteUid : "",
		  restUrl: _wpApAdminSettings ? _wpApAdminSettings.restUrl : "",
		  pluginApiUrl: `${_wpApAdminSettings ? _wpApAdminSettings.internalAPIUrl : ""}myfastapp/v1/`,
		  azureApiUrl: `${_wpApAdminSettings ? _wpApAdminSettings.externalAPIUrl : ""}`,
		  wordPressApiUrl: `${_wpApAdminSettings ? _wpApAdminSettings.internalAPIUrl : ""}wp/v2/`,
		  wordPressNonce: _wpApAdminSettings ? _wpApAdminSettings.nonce : "",
		  platformVersion: _wpApAdminSettings ? _wpApAdminSettings.platformVersion : "0",
		  pluginVersion: _wpApAdminSettings ? _wpApAdminSettings.pluginVersion : "0",
		  locale: _wpApAdminSettings ? _wpApAdminSettings.wp_locale : "en-US",
		  assetsUrl: _wpApAdminSettings ? _wpApAdminSettings.assetsUrl : "",
		  adminEmail: _wpApAdminSettings ? _wpApAdminSettings.adminEmail : "",
		  apiKey: _wpApAdminSettings ? _wpApAdminSettings.apiKey : "",
	 });

	const getApiKeyAsync = Baseline.GetApiKeyInternal;

	 const getAssetUrl = (assetPath) => {
		  return `${plugin.assetsUrl}/${assetPath}`;
	 }

	 return (
		  <Provider value={{
				plugin,
				getApiKeyAsync,
				getAssetUrl
		  }}>
				{props.children}
		  </Provider>
	 );
}